import React, { createContext, useState, useContext } from 'react';

// Create Address Context
const AddressContext = createContext();

// Custom hook for consuming Address Context
export const useAddress = () => {
  return useContext(AddressContext);
};

// Address Provider component
export const AddressProvider = ({ children }) => {
  const [savedAddress, setSavedAddress] = useState(null); // State to store the address

  return (
    <AddressContext.Provider value={{ savedAddress, setSavedAddress }}>
      {children}
    </AddressContext.Provider>
  );
};
